import OmegaRepository from '@/_shared/repositories/omega.respository';
import BackofficeServicesRepository from '@/_shared/repositories/backoffice-services.repository';
import PrivacySettingsDTO from '../interfaces/privacy-settings.type';

class AccountSettingsService {
  private omegaRepository: OmegaRepository = new OmegaRepository();
  private backOfficeRepository: BackofficeServicesRepository = new BackofficeServicesRepository();

  getPrivacySettings(repDID: number): Promise<PrivacySettingsDTO> {
    return this.backOfficeRepository.get(`distributors/privacy-settings/${repDID}`).then(
      (res: any) => (res.data.privacy_settings),
    );
  }

  setPrivacySettings(repDID: number,
    settings: PrivacySettingsDTO) {
    return this.backOfficeRepository.put(`distributors/privacy-settings/${repDID}`, settings);
  }

  getHoldingTankSettings(repDID: number): Promise<{ holding_tank_in_use: boolean }> {
    return this.omegaRepository.get(`/rep/holding-tank-setting/${repDID}`, { withCredentials: true }).then((res) => res.data.data);
  }

  setHoldingTankSettings(repDID: number, data: { holding_tank_in_use: boolean }) {
    return this.omegaRepository.patch(`/rep/holding-tank-setting/${repDID}`, {
      data,
    });
  }

  /* eslint-disable @typescript-eslint/camelcase */
  changePassword(repDid: number, currentPassword: string, newPassword: string) {
    const formData = {
      old_password: currentPassword,
      new_password: newPassword,
    };

    return this.omegaRepository.post(`/rep/${repDid}/profile/password`, formData);
  }
  /* eslint-enable @typescript-eslint/camelcase */

  isPasswordValid(password: string): boolean {
    const hasMinimumLength = password.length > 8;
    const matchRequirements = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/.test(password);
    return (hasMinimumLength && matchRequirements);
  }
}

export default new AccountSettingsService();
